// Local translations
export const T = {
  en_GB: {
    platformsMissingPortfoliosWarning:
      "Some platforms have no model portfolio assigned. Goals on such a platform can never be advised a model portfolio — assign at least one active model portfolio to each platform (in the Portfolios tab, edit a portfolio's platforms).",
  },
  nb_NO: {
    platformsMissingPortfoliosWarning:
      "Noen plattformer har ingen modellportefølje tilordnet. Mål på en slik plattform kan aldri få råd om en modellportefølje — tilordne minst én aktiv modellportefølje til hver plattform (rediger porteføljens plattformer i Porteføljer-fanen).",
  },
} as const;
